import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Loading from "../../components/Main/Loading";
import ToastError from "../../components/Notification/ToastError";
import ImageShow from "../../components/Product/Images";
import ProductDetail from "../../components/Product/Product";
import {
  getSession,
  getStorage,
  getStorageEmail,
  getStorageExp,
  headers,
  isEmpty,
  setSession,
  useWindowsSize,
} from "../../libs";
import { ValCart } from "../../validation/CartValidation";

const initData = {
  id: 0,
  name: "",
  price: 0,
  description: "",
  image: "",
  status: 0,
  info: 0,
  qty: 0,
  detail_paket: [],
  sold: 0,
};

const initCart = {
  id: 0,
  name: "",
  price: 0,
  vanilla_price: 0,
  jam_pemeriksaan: "",
  tgl_pemeriksaan: "",
  note: "",
  info: 1, //1. Satuan -- 2. Paket -- 3. Product (Media)
  active: true,
  image: "",
  stock: 0,
};

function Service(props) {
  const id = props.match.params.id;
  const location = useLocation();
  const history = useHistory();
  const size = useWindowsSize();
  const parameter = location.pathname.split("/")[2]; // checking paket atau satuan

  const [layanan, setLayanan] = useState([]);
  const [data, setData] = useState(initData);
  const [cart, setCart] = useState(initCart);
  const [isSession, setDataSession] = useState({});
  const [loading, setLoading] = useState([]);
  const [tab, setTab] = useState("1"); // 1. Description, 2. Info, 3. Ulasan
  const [isVisible, setVisible] = useState(false);
  const [isProduct, setIsProduct] = useState(false);

  const [qty, setQty] = useState(1);
  const [loadCart, setLoadCart] = useState(false);
  const [isError, setError] = useState([]);

  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");
  const onError = () => {
    setOpen(false);
  };

  /** Get Menu Layanan Footer */
  const GetDataLayanan = async () => {
    setLoading(true);
    if (parameter === "paket") {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/katalog/paket`,
          { offset: 0, limit: 10 },
          { headers: await headers({ offset: 0, limit: 10 }) }
        );

        if (Number(response.data.code) === 200) {
          setLayanan(response.data.data.reverse());
          setLoading(false);
        } else {
          setOpen(true);
          setResponse("");
          setLoading(false);
        }
      } catch (e) {
        setOpen(true);
        setResponse("");
        setLoading(false);
      }
    } else if (parameter === "satuan") {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/katalog/satuan`,
          { offset: 0, limit: 10 },
          { headers: await headers({ offset: 0, limit: 10 }) }
        );

        if (Number(response.data.code) === 200) {
          setLayanan(response.data.data.reverse());
          setLoading(false);
        } else {
          setOpen(true);
          setResponse("");
          setLoading(false);
        }
      } catch (e) {
        setOpen(true);
        setResponse("");
        setLoading(false);
      }
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/katalog/product`,
          { offset: 0, limit: 10 },
          { headers: await headers({ offset: 0, limit: 10 }) }
        );

        if (Number(response.data.code) === 200) {
          setLayanan(response.data.data.reverse());
          setLoading(false);
        } else {
          setOpen(true);
          setResponse("");
          setLoading(false);
        }
      } catch (e) {
        setOpen(true);
        setResponse("");
        setLoading(false);
      }
    }
  };

  /** Get Data Product Detail */
  const GetData = async () => {
    setLoading(true);
    if (parameter === "paket") {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/katalog/paket/detail`,
          { id },
          { headers: await headers({ id }) }
        );

        if (Number(response.data.code) === 200) {
          const filter_covid = response.data.data.detail_paket.filter(
            (it) => it.parameter.is_covid === 1
          );

          setData({
            ...data,
            id: response.data.data.id,
            name: response.data.data.name,
            price: response.data.data.total_harga,
            description: response.data.data.keterangan,
            image: response.data.data.image,
            status: response.data.data.status,
            status_no: response.data.data.status_no,
            status_text: response.data.data.status_text,
            is_covid: filter_covid.length > 0 ? 1 : 0,
            info: 2,
            detail_paket: response.data.data.detail_paket,
            sold: response.data.data.sold,
          });

          setCart({
            ...cart,
            id: response.data.data.id,
            name: response.data.data.name,
            price: response.data.data.total_harga,
            vanilla_price: response.data.data.total_harga,
            image: response.data.data.image,
            is_covid: filter_covid.length > 0 ? 1 : 0,
            info: 2,
            stock: 2,
            active: true,
          });

          setLoading(false);
        } else {
          history.push("/page-not-found");
        }
      } catch (e) {
        history.push("/page-not-found");
      }
    } else if (parameter === "satuan") {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/katalog/satuan/detail`,
          { id },
          { headers: await headers({ id }) }
        );

        if (Number(response.data.code) === 200) {
          setData({
            ...data,
            id: response.data.data.id,
            name: response.data.data.name,
            price: response.data.data.harga,
            description: response.data.data.keterangan,
            image: response.data.data.image,
            status: response.data.data.status,
            status_no: response.data.data.status_no,
            status_text: response.data.data.status_text,
            is_covid: response.data.data.is_covid,
            info: 1,
            layanan: [],
            sold: response.data.data.sold,
          });

          setCart({
            ...cart,
            id: response.data.data.id,
            name: response.data.data.name,
            price: response.data.data.harga,
            vanilla_price: response.data.data.harga,
            image: response.data.data.image,
            is_covid: response.data.data.is_covid,
            info: 1,
            stock: 2,
            active: true,
          });

          setLoading(false);
        } else {
          history.push("/page-not-found");
        }
      } catch (e) {
        history.push("/page-not-found");
      }
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/katalog/product/detail`,
          { id },
          { headers: await headers({ id }) }
        );

        if (Number(response.data.code) === 200) {
          setData({
            ...data,
            id: response.data.data.id,
            name: response.data.data.name,
            price: response.data.data.harga,
            description: response.data.data.keterangan,
            image: response.data.data.image,
            status: response.data.data.status,
            status_no: response.data.data.status_no,
            status_text: response.data.data.status_text,
            is_covid: 0,
            qty: response.data.data.qty,
            info: 3,
            layanan: [],
            sold: response.data.data.sold,
          });

          setCart({
            ...cart,
            id: response.data.data.id,
            name: response.data.data.name,
            price: response.data.data.harga,
            vanilla_price: response.data.data.harga,
            image: response.data.data.image,
            is_covid: 0,
            info: 3,
            stock: response.data.data.qty,
            active: true,
          });

          setLoading(false);
        } else {
          history.push("/page-not-found");
        }
      } catch (e) {
        history.push("/page-not-found");
      }
    }
  };

  useEffect(() => {
    GetData();
    GetDataLayanan();

    const dataSession = getSession();
    if (!dataSession) {
      setDataSession({});
    } else {
      setDataSession(JSON.parse(dataSession));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (location) {
      if (location.pathname.includes("product")) {
        setIsProduct(true);
      } else {
        setIsProduct(false);
      }
    }
  }, [location]);

  /** Handle Tab Deskripsi dan Detail Paket */
  const onTab = (value) => {
    setTab(value);
  };

  /** Handle Quantity */
  const onQty = (operator) => {
    if (operator === "min") {
      let value = qty - 1;
      setQty(value);
    } else if (operator === "plus") {
      let value = qty + 1;
      setQty(value);
    }
  };

  /** Handle Input */
  const onSelect = (e) => {
    const { name, value } = e.target;
    setCart({ ...cart, [name]: value });
    setError([]);
  };

  /** Handle Submit Cart */
  const onCart = async (qty, section) => {
    // 1. Langsung cart, 2. Belanja lagi - section = buat janji atau tambahkan

    const initToken = getStorage();
    const initXtoken = await getStorageEmail();
    const initExptoken = await getStorageExp();

    const isMobile = size.width <= 640 ? true : false;

    setLoadCart(true);
    const error = await ValCart(cart, "order", isMobile, isProduct);

    if (initToken && initXtoken && initExptoken) {
      if (error.length > 0) {
        setError(error);
        setLoadCart(false);
      } else {
        let nowCart = { ...cart, price: data.price * qty, qty };

        //Awal membuat session (Session is Empty)
        if (isEmpty(isSession)) {
          let emptyCart = { item: { product: [], parameter: [], paket: [] } };

          if (cart.info === 1) {
            //Metode Satuan
            emptyCart.item.parameter.push(nowCart);
          } else if (cart.info === 2) {
            //Metode Paket
            emptyCart.item.paket.push(nowCart);
          } else if (cart.info === 3) {
            //Metode Product
            emptyCart.item.product.push(nowCart);
          }

          setSession(JSON.stringify(emptyCart));

          if (section === 1) {
            history.push("/cart");
          } else {
            history.push("/");
          }

          setLoadCart(false);
        } else {
          //Jika session sudah ada
          if (cart.info === 1) {
            const double = isSession.item.parameter.filter(
              (it) => it.id === cart.id
            );

            if (!double.length > 0) {
              await isSession.item.parameter.push(nowCart);
              setSession(JSON.stringify(isSession));

              if (section === 1) {
                history.push("/cart");
              } else {
                history.push("/");
              }

              setLoadCart(false);
            } else {
              setOpen(true);
              setResponse(
                "Kamu sudah menambahkan item tersebut, Silahkan check keranjang kamu"
              );
              setLoadCart(false);
            }
          } else if (cart.info === 2) {
            const double = isSession.item.paket.filter(
              (it) => it.id === cart.id
            );

            if (!double.length > 0) {
              await isSession.item.paket.push(nowCart);
              setSession(JSON.stringify(isSession));

              if (section === 1) {
                history.push("/cart");
              } else {
                history.push("/");
              }

              setLoadCart(false);
            } else {
              setOpen(true);
              setResponse(
                "Kamu sudah menambahkan item tersebut, Silahkan check keranjang kamu"
              );
              setLoadCart(false);
            }
          } else if (cart.info === 3) {
            const double = isSession.item.product.filter(
              (it) => it.id === cart.id
            );

            if (!double.length > 0) {
              await isSession.item.product.push(nowCart);
              setSession(JSON.stringify(isSession));

              if (section === 1) {
                history.push("/cart");
              } else {
                history.push("/");
              }

              setLoadCart(false);
            } else {
              setOpen(true);
              setResponse(
                "Kamu sudah menambahkan item tersebut, Silahkan check keranjang kamu"
              );
              setLoadCart(false);
            }
          }
        }
      }
    } else {
      setLoadCart(false);
      setOpen(true);
      setResponse(
        "Silahkan masuk untuk menikmati layanan, apabila kamu belum memiliki akun silahkan untuk mendaftar"
      );
    }
  };

  /** Handle Visible Modal*/

  const onModal = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <>
      <ToastError props={{ open, response, onError }} />
      {!loading ? (
        <>
          <ImageShow
            props={{ isVisible, onClose, dataImage: data?.image ?? [] }}
          />
          <ProductDetail
            props={{
              loading,
              layanan,
              data,
              parameter,
              onTab,
              tab,
              onCart,
              qty,
              onQty,
              onSelect,
              loadCart,
              isError,
              onModal,
            }}
          />
        </>
      ) : (
        <Loading />
      )}
    </>
  );
}

export default Service;
